var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2749_6790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3777 5.7993V16.9314H8.68693V5.7993H11.3777ZM11.7466 2.55515C11.7466 2.78661 11.6996 3.00361 11.6056 3.20614C11.5115 3.40868 11.385 3.58589 11.2258 3.7378C11.0739 3.8897 10.8931 4.01266 10.6833 4.1067C10.4736 4.1935 10.2493 4.2369 10.0106 4.2369C9.77916 4.2369 9.55855 4.1935 9.34878 4.1067C9.14625 4.01266 8.96903 3.8897 8.81713 3.7378C8.66523 3.58589 8.54226 3.40868 8.44823 3.20614C8.36143 3.00361 8.31803 2.78661 8.31803 2.55515C8.31803 2.31645 8.36143 2.09221 8.44823 1.88245C8.54226 1.67268 8.66523 1.49185 8.81713 1.33995C8.96903 1.18805 9.14625 1.0687 9.34878 0.981896C9.55855 0.887862 9.77916 0.840845 10.0106 0.840845C10.2493 0.840845 10.4736 0.887862 10.6833 0.981896C10.8931 1.0687 11.0739 1.18805 11.2258 1.33995C11.385 1.49185 11.5115 1.67268 11.6056 1.88245C11.6996 2.09221 11.7466 2.31645 11.7466 2.55515Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2749_6790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoInfo);
export default __webpack_public_path__ + "static/media/icono-info.f47e071adaea9fb3dece0b831cabeae9.svg";
export { ForwardRef as ReactComponent };